import createModel, { prop } from './lib/create_model';

const HallucinationFailureReason = createModel({
  modelName: 'HallucinationFailureReason',

  properties: {
    source: prop(Number),
    statement: prop(String),
    rationale: prop(String),
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

const ComponentMetadata = createModel({
  modelName: 'ComponentMetadata',

  properties: {
    rationale: prop(String),
    rationaleCategories: prop([String]),
    numberOfSentences: prop(Number),
    numberIncorrect: prop(Number),
    context: prop(String),
    sentences: prop([String]),
    threadId: prop(String),
    contactId: prop(String),
    failures: prop([HallucinationFailureReason]),
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

const QCResult = createModel({
  modelName: 'QCResult',

  properties: {
    passes: prop(Boolean),
    metadata: prop(ComponentMetadata),
    components: prop(Object),
    originalBotMessage: prop(String),
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

const AIQualityCheck = createModel({
  modelName: 'AIQualityCheck',

  properties: {
    isSkipped: prop(Boolean),
    causedByItemIds: prop([String]),
    guideType: prop(String),
    guideId: prop(String),
    qualityCheckResult: prop(QCResult),
  },

  statics: {
    create(attrs) {
      return new this(attrs);
    },
  },
});

export default AIQualityCheck;
